import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Bell, Check, CheckCheck } from "lucide-react";

export default function Notifications() {
  const qc = useQueryClient();
  const { data: notifs } = useQuery({
    queryKey: ["notifications"],
    queryFn: async () => (await api.get("/notifications")).data,
  });

  const markRead = async (id) => {
    await api.post(`/notifications/${id}/read`);
    qc.invalidateQueries({ queryKey: ["notifications"] });
  };
  const markAll = async () => {
    await api.post("/notifications/read-all");
    qc.invalidateQueries({ queryKey: ["notifications"] });
  };

  return (
    <div className="p-4 md:p-8 max-w-3xl">
      <div className="flex items-start justify-between mb-6">
        <div>
          <div className="label-caps text-muted-foreground mb-2">Alerts</div>
          <h1 className="font-display text-3xl md:text-4xl font-black tracking-tight">Notifications</h1>
        </div>
        <Button variant="outline" size="sm" onClick={markAll}><CheckCheck className="w-4 h-4 mr-1" />Mark all read</Button>
      </div>

      <div className="border border-border bg-card rounded-2xl divide-y divide-border overflow-hidden">
        {(notifs || []).map((n) => (
          <div key={n.id} className={`p-4 flex items-start justify-between gap-4 ${n.read ? "" : "bg-primary/5"}`} data-testid={`notif-${n.id}`}>
            <div className="flex items-start gap-3 min-w-0">
              <div className={`w-9 h-9 rounded-xl flex items-center justify-center shrink-0 ${n.read ? "bg-muted text-muted-foreground" : "bg-primary/10 text-primary"}`}>
                <Bell className="w-4 h-4" />
              </div>
              <div className="min-w-0">
                <div className="font-medium text-sm">{n.title}</div>
                <div className="text-xs text-muted-foreground mt-0.5 truncate">{n.message}</div>
                <div className="text-[0.65rem] text-muted-foreground mt-1 font-mono">{new Date(n.at).toLocaleString()}</div>
                {n.entity_type === "task" && n.entity_id && (
                  <Link to={`/app/tasks/${n.entity_id}`} className="text-xs text-primary hover:underline mt-1 inline-block">Open task →</Link>
                )}
              </div>
            </div>
            {!n.read && (
              <Button variant="ghost" size="icon" onClick={() => markRead(n.id)}><Check className="w-4 h-4" /></Button>
            )}
          </div>
        ))}
        {(!notifs || notifs.length === 0) && (
          <div className="p-12 text-center text-muted-foreground">
            <Bell className="w-8 h-8 mx-auto mb-2" />
            No notifications yet.
          </div>
        )}
      </div>
    </div>
  );
}
